export const MY_CUSTOM_METRIC = 10;
export const PUBLIC_CUSTOM_METRIC = 11;

export const TRACKER_PAGE = 0;
export const TRACKER_COHORT_PAGE = 5;
export const TRACKER_CHART_PAGE = 7;
